/* import __COLOCATED_TEMPLATE__ from './restrict-to-user-tickets.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type HelpCenterSite from 'embercom/models/help-center-site';

interface Args {
  selectedHelpCenter: HelpCenterSite;
}

interface Signature {
  Args: Args;
}

export default class TicketsPortalRestrictToUserTickets extends Component<Signature> {
  @action
  toggleTicketsPortalRestrictToUserTickets() {
    this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets =
      !this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }

  get isTicketsPortalRestrictToUserTicketsEnabled() {
    return this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tickets::TicketsPortal::RestrictToUserTickets': typeof TicketsPortalRestrictToUserTickets;
    'new-settings/helpdesk/tickets/tickets-portal/restrict-to-user-tickets': typeof TicketsPortalRestrictToUserTickets;
  }
}
